class AddStickyOnScrollOut {
  constructor(selector, elementToRemoveSticky) {
    this.triggerElement = document.querySelector(selector);
    this.elementToRemoveSticky = document.querySelector(elementToRemoveSticky);
    this.body = document.body;
    this.isStickyAdded = false;
    if (this.triggerElement && this.body) {
      this.initIntersectionObserver();
    }
  }

  initIntersectionObserver() {
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];

      if (entry.intersectionRatio <= 0.8 && !this.isStickyAdded) {
        this.body.classList.add('sticky');
        this.isStickyAdded = true;
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    });

    observer.observe(this.triggerElement);

    const observerHeader = new IntersectionObserver(entries => {
      const entry = entries[0];

      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        this.body.classList.remove('sticky');
        this.isStickyAdded = false;
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    });

    observerHeader.observe(this.elementToRemoveSticky);
  }
}

// Usage:
const stickyScrollOut = new AddStickyOnScrollOut('.secondary-navigation', '.header');

class ScrollDirection {
  constructor() {
    this.lastScrollTop = 0;
    this.initScrollListener();
  }

  initScrollListener() {
    window.addEventListener('scroll', () => {
      let currentScroll = window.scrollY || document.documentElement.scrollTop;

      if (currentScroll > this.lastScrollTop) {
        document.body.classList.remove('sticky-up');
        document.body.classList.add('sticky-down');
      } else {
        document.body.classList.add('sticky-up');
        document.body.classList.remove('sticky-down');
      }

      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
  }
}

// Initialize the ScrollDirection class
new ScrollDirection();


class FooterNav {
  constructor() {
    this.titles = document.querySelectorAll('.top-footer-nav__title');
    this.addEventListeners();
  }

  addActiveClass(event) {
    const title = event.target.closest('.top-footer-nav__title');
    const wrap = title.parentElement;

    this.titles.forEach(titleElement => {
      if (titleElement !== title) {
        titleElement.parentElement.classList.remove('active');
      }
    });

    wrap.classList.toggle('active');
  }

  addEventListeners() {
    this.titles.forEach(title => {
      title.addEventListener('click', this.addActiveClass.bind(this));
    });
  }
}

const footerNav = new FooterNav();

document.querySelectorAll('a[href^="#"]:not(.load-more,.js-show-recover,.js-show-login)').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    smoothScroll(this.getAttribute('href').substring(1));
  });
});

// Function for smooth scrolling
function smoothScroll(targetId) {
  const targetElement = document.getElementById(targetId);

  if (targetElement) {
    const duration = 1500;
    const start = window.scrollY;
    const target = targetElement.getBoundingClientRect().top + window.scrollY - 80; // Subtracting 100px
    const distance = target - start;
    let startTime = null;

    function customEasing(t) {
      if (t < 0.3) {
        return t * t;
      } else if (t < 0.7) {
        return t;
      } else {
        return t * (2 - t);
      }
    }

    function scrollAnimation(currentTime) {
      if (!startTime) {
        startTime = currentTime;
      }

      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easedProgress = customEasing(progress);

      window.scrollTo(0, start + distance * easedProgress);

      if (timeElapsed < duration) {
        requestAnimationFrame(scrollAnimation);
      }
    }

    requestAnimationFrame(scrollAnimation);
  }
}

// Check if the page loads with a hash link and scroll to it
window.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;
  if (hash) {
    const targetId = hash.substring(1);
    smoothScroll(targetId);
  }
});

document.querySelector('.js-mobile-search')?.addEventListener('click', e => {
  e.preventDefault();
  document.querySelector('.mobile-search').classList.toggle('active');
});

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

document.querySelector('.js-show-recover')?.addEventListener('click', e => {
  e.preventDefault();
  document.querySelector('#recover').style.display = 'block';
  document.querySelector('#recover+div').style.display = 'block';
  document.querySelector('#login').style.display = 'none';
  document.querySelector('#login+div').style.display = 'none';
});

document.querySelector('.js-show-login')?.addEventListener('click', e => {
  e.preventDefault();
  document.querySelector('#recover').style.display = 'none';
  document.querySelector('#recover+div').style.display = 'none';
  document.querySelector('#login').style.display = 'block';
  document.querySelector('#login+div').style.display = 'block';
});

document.querySelector('.two-col-section__btn')?.addEventListener('click', e => {
  e.preventDefault();
  const currentBtn = e.currentTarget;
  const twoColWrap = currentBtn.closest('.two-col-section');
  twoColWrap.classList.toggle('active');
  if (twoColWrap.classList.contains('active')) {
    currentBtn.innerHTML = 'Read Less';
  } else {
    currentBtn.innerHTML = 'Read More';
  }
});

const svgIcon = document.getElementById('svgIcon');
svgIcon?.addEventListener('click', e => {
  e.preventDefault();
  document.querySelector('.mobile-nav-holder').classList.add('active');
});

document.querySelector('.mobile-nav-close')?.addEventListener('click', e => {
  document.querySelector('.mobile-nav-holder').classList.remove('active');
});

const brandSubContainer = document.querySelectorAll('.brand-sub-nav__wrapper');
const prevBtn = document.querySelectorAll('.brand-sub-nav__wrapper .icon-left');
const nextBtn = document.querySelectorAll('.brand-sub-nav__wrapper .icon-right');

function checkOverflow() {
  brandSubContainer.forEach(container => {
    const brandSubList = container.querySelector('.brand-sub-nav__list');

    const isOverflowing = brandSubList.scrollWidth > brandSubList.clientWidth;
    if (isOverflowing) {
      container.classList.add('brand-sub-nav__wrapper--overflow');
    } else {
      container.classList.remove('brand-sub-nav__wrapper--overflow');
    }
  });
}

function slideContent(direction) {
  brandSubContainer.forEach(container => {
    const brandSubList = container.querySelector('.brand-sub-nav__list');
    const isOverflowing = container.classList.contains('brand-sub-nav__wrapper--overflow');
    const distance = brandSubList.clientWidth;

    if (isOverflowing) {
      const currentScroll = brandSubList.scrollLeft;
      let newScroll;

      if (direction === 'prev') {
        newScroll = currentScroll - distance;
      } else if (direction === 'next') {
        newScroll = currentScroll + distance;
      }

      brandSubList.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
    }
  });

}

window.addEventListener('resize', checkOverflow);
window.addEventListener('load', checkOverflow);
prevBtn.forEach(btn => btn?.addEventListener('click', () => slideContent('prev')));
nextBtn.forEach(btn => btn?.addEventListener('click', () => slideContent('next')));

